import { takeLatest, put, call } from 'redux-saga/effects';
import { TasksTypes, TasksAction, Task } from '../types';
import { saveTasks, getListTasks, deleteTask, deleteTasks } from '../actions';
import { deleteTaskFirebase, deleteTasksFirebase, getTasksFirebase, saveTasksFirebase } from '../repository';

export function* requestGetListTasksSaga(props: TasksAction<{ ids: string[] }>): unknown {
    try {
        const tasks = yield call(getTasksFirebase, props.payload.ids);
        yield put(getListTasks(tasks));
    } catch (err: unknown) {
        yield put(getListTasks([]));
    }
}

export function* requestSaveTasksSaga(props: TasksAction<{ tasks: Task[] }>): unknown {
    try {
        const tasks = yield call(saveTasksFirebase, props.payload.tasks);
        yield put(saveTasks(tasks));
    } catch (err: unknown) {
        yield put(saveTasks());
    }
}

export function* requestDeleteTaskSaga(props: TasksAction<{ id: string }>): unknown {
    try {
        const tasks = yield call(deleteTaskFirebase, props.payload.id);
        yield put(deleteTask(tasks));
    } catch (err: unknown) {
        yield put(deleteTask());
    }
}

export function* requestDeleteTasksSaga(props: TasksAction<{ ids: string[] }>): unknown {
    try {
        const tasks = yield call(deleteTasksFirebase, props.payload.ids);
        yield put(deleteTasks(tasks));
    } catch (err: unknown) {
        yield put(deleteTasks());
    }
}

export default [
    takeLatest(TasksTypes.REQUEST_GET_LIST_TASKS, requestGetListTasksSaga),
    takeLatest(TasksTypes.REQUEST_SAVE_TASKS, requestSaveTasksSaga),
    takeLatest(TasksTypes.REQUEST_DELETE_TASK, requestDeleteTaskSaga),
    takeLatest(TasksTypes.REQUEST_DELETE_TASKS, requestDeleteTasksSaga),
];
